import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { SinSidebarLayout } from 'layouts/SinSidebarLayout';

export const PoliticasPrivacidad = () => {
  const Section = ({ number, title, children, level = 1 }) => {
    // Mapeo de indentación por nivel
    const indentClass =
      {
        1: 'pl-0',
        2: 'pl-4',
        3: 'pl-8',
        4: 'pl-12'
      }[level] || 'pl-16'; // niveles mayores siguen aumentando

    return (
      <div className={`section level-${level} mb-4 ${indentClass}`}>
        <Heading type={`h${level + 3}`}>
          {number} {title}
        </Heading>
        {children}
      </div>
    );
  };

  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <div className="bg-white rounded shadow-md p-4 pb-24 sm:px-10 sm:pt-10 relative mb-16">
        <Heading type="h2" className="text-center">
          POLÍTICA DE PRIVACIDAD Y TRATAMIENTO DE DATOS PERSONALES
        </Heading>
        <div className="bg-background-primary p-5 sm:p-10 rounded">
          <Text className="mb-6 font-semibold text-sm text-gray-600">
            Fecha de Última Actualización: 14 de diciembre de 2025
          </Text>

          <Section
            number="TÍTULO I:"
            title="INFORMACIÓN GENERAL Y RESPONSABLE DEL TRATAMIENTO"
          ></Section>
          <Section number="1." title="Responsable del Tratamiento y Contacto">
            <Section
              number="1.1"
              title="Identificación del Responsable"
              level={2}
            >
              <Text className="mb-4">
                El responsable del tratamiento de los datos personales es{' '}
                <strong>"NEWEND SPA"</strong>, RUT N°78.074.664-5, domiciliada
                en{' '}
                <strong>
                  "Avenida Providencia N°1363, Oficina 1102, comuna de
                  Providencia, Región Metropolitana"
                </strong>
                .
              </Text>
            </Section>

            <Section number="1.2" title="Contacto de Privacidad" level={2}>
              <Text className="mb-4">
                Para cualquier consulta, reclamo o ejercicio de derechos, el{' '}
                <strong>"Titular"</strong> puede dirigirse al correo
                electrónico:
                <a
                  href="mailto:contacto@plataforma-industria-circular.cl"
                  className="text-blue-600 underline"
                >
                  contacto@plataforma-industria-circular.cl
                </a>
                .
              </Text>
            </Section>

            <Section number="1.3" title="Alcance" level={2}>
              <Text className="mb-4">
                Esta <strong>"Política"</strong> aplica a los datos personales
                de las <strong>"Personas Naturales"</strong> que se registran
                y/o interactúan con la
                <strong>"Plataforma Industria Circular (PIC)"</strong>,
                incluyendo los datos de los representantes legales, apoderados y
                contactos de las <strong>"Personas Jurídicas"</strong> (
                <strong>"Titulares"</strong>).
              </Text>
            </Section>
          </Section>

          <Section
            number="2."
            title="Principios Rectores del Tratamiento de Datos"
          >
            <Text className="mb-4">
              El tratamiento de datos personales a los que el{' '}
              <strong>"Operador"</strong> tenga acceso mediante la
              <strong>"PIC"</strong>, se rige estrictamente por los siguientes
              principios:
            </Text>

            <table
              className="table-auto w-full border-collapse text-left"
              style={{ backgroundColor: 'rgb(239, 245, 244)' }}
            >
              <thead style={{ backgroundColor: '#55afbd', color: 'white' }}>
                <tr>
                  <th className="border border-white px-4 py-2 font-bold">
                    Principio
                  </th>
                  <th className="border border-white px-4 py-2 font-bold">
                    Descripción
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Licitud y Lealtad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    El tratamiento se realiza sobre una base legal válida
                    (principalmente el consentimiento informado y expreso) y de
                    forma transparente para el <strong>"Titular"</strong>.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Finalidad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Los datos son recolectados con fines específicos, explícitos
                    y legítimos (establecidos en los <strong>"T&C"</strong>). No
                    se tratarán posteriormente de forma incompatible con dichos
                    fines.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Proporcionalidad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Solo se recolectarán datos pertinentes, adecuados y
                    estrictamente necesarios para cumplir con la finalidad
                    declarada. Asimismo, serán conservados solo por el período
                    necesario para cumplir con el fin para el cual fueron
                    recolectados, salvo obligación legal.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Calidad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Se mantendrá la exactitud, veracidad y actualización
                    oportuna de los datos personales recolectados.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Responsabilidad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Adopción de medidas técnicas y organizativas necesarias para
                    realizar el tratamiento de datos personales bajo lo
                    establecido en la normativa vigente en la materia.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Confidencialidad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Toda información relativa al tratamiento y a los datos
                    recolectados estará sujeta al estricto secreto y
                    confidencialidad.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Transparencia</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    La <strong>"Plataforma"</strong> garantiza que la
                    información relativa al tratamiento sea clara, simple,
                    comprensible y permanentemente accesible.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Seguridad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Adopción de medidas técnicas y organizativas para proteger
                    los datos contra el tratamiento no autorizado, ilícito o la
                    pérdida accidental.
                  </td>
                </tr>
              </tbody>
            </table>
          </Section>
          <Section
            number="TÍTULO II:"
            title="CATEGORÍAS DE DATOS Y FINALIDADES"
          ></Section>
          <Section
            number="3."
            title="Datos Recolectados y Propósitos del Tratamiento"
          >
            <Text className="mb-4">
              La <strong>"Plataforma"</strong> recolecta y trata las siguientes
              categorías de datos personales, con la finalidad específica de
              permitir la operatividad de la <strong>"PIC"</strong>:
            </Text>

            <table
              className="table-auto w-full border-collapse text-left"
              style={{ backgroundColor: 'rgb(239, 245, 244)' }}
            >
              <thead style={{ backgroundColor: '#55afbd', color: 'white' }}>
                <tr>
                  <th className="border border-white px-4 py-2 font-bold">
                    Categoría de Datos
                  </th>
                  <th className="border border-white px-4 py-2 font-bold">
                    Ejemplos de Datos Recolectados
                  </th>
                  <th className="border border-white px-4 py-2 font-bold">
                    Finalidad Específica del Tratamiento
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Identificación y Contacto</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Nombre completo, RUT/CI, correo electrónico, teléfono,
                    dirección postal.
                  </td>
                  <td className="border border-white px-4 py-2">
                    Gestión del registro, autenticación del{' '}
                    <strong>"Usuario"</strong> y verificación de identidad.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Datos Profesionales/Empresariales</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Razón Social, Giro de la empresa, Cargo, flujos de recursos
                    o residuos no peligrosos asociados al contacto.
                  </td>
                  <td className="border border-white px-4 py-2">
                    Perfilamiento en el Directorio, difusión de ofertas/demandas
                    y facilitación de la conexión de negocios con otros{' '}
                    <strong>"Usuarios"</strong>.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Datos de Conectividad</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Dirección IP, datos de uso, navegación y hora de conexión.
                  </td>
                  <td className="border border-white px-4 py-2">
                    Análisis de seguridad, mejoramiento de la{' '}
                    <strong>"Plataforma"</strong> y fines estadísticos internos.
                  </td>
                </tr>
                <tr>
                  <td className="border border-white px-4 py-2">
                    <strong>Análisis de Ecosistema</strong>
                  </td>
                  <td className="border border-white px-4 py-2">
                    Información sobre brechas, patrones de recursos/residuos y
                    oportunidades de conexión.
                  </td>
                  <td className="border border-white px-4 py-2">
                    Investigación, análisis estadístico y generación de reportes
                    agregados (sin identificación individual) para desarrollar
                    soluciones que beneficien al ecosistema de la{' '}
                    <strong>"Economía Circular"</strong>.
                  </td>
                </tr>
              </tbody>
            </table>
          </Section>
          <Section number="4." title="Transferencia y Cesión de Datos">
            <Section number="4.1" title="Comunicación Necesaria" level={2}>
              <Text className="mb-4">
                El <strong>"Usuario"</strong> acepta que, al publicar una oferta
                o demanda de materiales/servicios en la <strong>"PIC"</strong>,
                sus datos de contacto esenciales (ej: nombre de la empresa,
                nombre del contacto, correo electrónico o teléfono) serán
                comunicados a los <strong>"Usuarios"</strong> interesados con el
                único objetivo de llevar a cabo la finalidad de la
                <strong>"Plataforma"</strong> según se define en los{' '}
                <strong>"T&C"</strong>. Dicha comunicación se fundamenta en el
                consentimiento expreso otorgado para la finalidad de la{' '}
                <strong>"Plataforma"</strong>.
              </Text>
            </Section>

            <Section
              number="4.2"
              title="Generación de Valor para el Ecosistema"
              level={2}
            >
              <Text className="mb-4">
                El <strong>"Operador"</strong> podrá utilizar la información y
                patrones de uso de la <strong>"Plataforma"</strong>, una vez
                anonimizados y agregados, para identificar tendencias, brechas y
                oportunidades de mejora dentro del sector, y así generar
                soluciones, herramientas o reportes que podrán ser puestos a
                disposición de los distintos actores del ecosistema de la
                <strong>"Economía Circular"</strong>, sin que esta actividad
                constituya una cesión de datos personales del{' '}
                <strong>"Usuario"</strong>.
              </Text>
            </Section>

            <Section
              number="4.3"
              title="Cesión a Terceros (No Operacionales)"
              level={2}
            >
              <Text className="mb-4">
                La cesión de datos personales a otros responsables (terceros
                ajenos a la operación funcional de la <strong>"PIC"</strong>)
                solo se realizará con el consentimiento expreso y específico del{' '}
                <strong>"Titular"</strong>, salvo que exista una excepción legal
                que lo permita.
              </Text>
            </Section>
          </Section>
          <Section number="5." title="Derechos de los Titulares">
            <Text className="mb-4">
              El <strong>"Titular"</strong> de los datos personales puede
              ejercer, en cualquier momento, los siguientes derechos ante el
              <strong>"Responsable del Tratamiento"</strong>:
            </Text>
            <ul className="list-disc list-inside mb-4">
              <li>
                <strong>Derecho de Acceso:</strong> Obtener confirmación sobre
                si sus datos están siendo tratados y acceder a ellos.
              </li>
              <li>
                <strong>Derecho de Rectificación:</strong> Modificar datos
                inexactos, desactualizados o incompletos.
              </li>
              <li>
                <strong>Derecho de Supresión:</strong> Pedir la eliminación de
                sus datos, bajo las causales legales, o la revocación del
                consentimiento.
              </li>
              <li>
                <strong>Derecho de Oposición:</strong> Oponerse a un tratamiento
                específico.
              </li>
              <li>
                <strong>Derecho a la Portabilidad:</strong> Recibir sus datos
                personales en un formato estructurado, de uso común e
                interoperable, y transferirlos a otro{' '}
                <strong>"Responsable"</strong>.
              </li>
            </ul>
          </Section>

          <Section number="6." title="Mecanismo de Ejercicio de Derechos">
            <Text className="mb-4">
              Las solicitudes para el ejercicio de los{' '}
              <strong>"Derechos de los Titulares"</strong> deberán presentarse
              por escrito, adjuntando la identificación del
              <strong>"Titular"</strong> y la descripción clara del derecho que
              se invoca, a la dirección de correo electrónico:
              <a
                href="mailto:contacto@plataforma-industria-circular.cl"
                className="text-blue-600 underline"
              >
                contacto@plataforma-industria-circular.cl
              </a>
              . La <strong>"Plataforma"</strong> responderá a la solicitud en
              los plazos establecidos por la legislación vigente.
            </Text>
          </Section>
        </div>
      </div>
    </SinSidebarLayout>
  );
};
